import React from 'react';
import Sidebar from './Sidebar';
import LogoutButton from './LogoutButton';

const Layout = ({ children }) => {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 ml-64">
        {/* Header with logout button */}
        <div className="bg-white border-b border-gray-200 px-6 py-4">
          <div className="flex justify-end">
            <LogoutButton />
          </div>
        </div>
        <div className="h-full overflow-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;